<template>
    <div>
        <ValidationObserver ref="observer"
                            tag="form"
                            class="row d-flex mx-2"
                            @submit.prevent="submit">
            <div class="col-sm-6 py-4">
                <ValidationProvider tag="div"
                                    class="mb-4"
                                    vid="name"
                                    mode="lazy"
                                    :customMessages="{required: 'Norādi darbinieka vārdu.'}"
                                    rules="required"
                                    v-slot="{errors}">
                    <label for="name" class="d-block text-secondary text-left mb-0">Vārds</label>
                    <input type="text" id="name" class="w-100 py-1 ds-input" v-model="user.name">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider tag="div"
                                    vid="surname"
                                    class="mb-4"
                                    mode="lazy"
                                    rules="required"
                                    :customMessages="{required: 'Norādi darbinieka uzvārdu.'}"
                                    v-slot="{errors}">
                    <label for="surname" class="d-block text-secondary text-left mb-0">Uzvārds</label>
                    <input type="text" id="surname" class="w-100 py-1 ds-input" v-model="user.surname">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider tag="div"
                                    vid="identityNumber"
                                    class="mb-4"
                                    mode="lazy"
                                    v-slot="{errors}">
                    <label for="identityNumber" class="d-block text-secondary text-left mb-0">Personas kods</label>
                    <input type="text" id="identityNumber" class="w-100 py-1 ds-input" v-model="user.identityNumber">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider tag="div"
                                    vid="address"
                                    class="mb-4"
                                    mode="lazy"
                                    v-slot="{errors}">
                    <label for="address" class="d-block text-secondary text-left mb-0">Deklarētā dzīvesvietas adrese</label>
                    <input type="text" id="address" class="w-100 py-1 ds-input" v-model="user.address">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider tag="div"
                                    vid="jobTitleId"
                                    class="mb-4"
                                    mode="lazy"
                                    rules="required"
                                    :customMessages="{required: 'Norādi darbinieka amatu identifikatoru.'}"
                                    v-slot="{errors}">
                    <label class="d-block text-secondary text-left mb-0">Amata nosaukums</label>
                    <b-form-select id="jobTitleId" class="w-100 py-1 ds-input" v-model="user.jobTitleId" :options="jobTitleOptions"/>
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider tag="div"
                                    vid="jobTitle"
                                    class="mb-4"
                                    mode="lazy"
                                    v-slot="{errors}">
                    <label for="jobTitle" class="d-block text-secondary text-left mb-0">Pielāgots amata nosaukums</label>
                    <input type="text" id="jobTitle" class="w-100 py-1 ds-input" v-model="user.jobTitle">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider tag="div"
                                    vid="workExperience"
                                    class="mb-4"
                                    mode="lazy"
                                    v-slot="{errors}">
                    <label for="jobTitle" class="d-block text-secondary text-left mb-0">Darba līguma noslēgšanas datums</label>
                    <b-form-datepicker id="workExperience" class="ds-input" v-model="user.workExperience" locale="lv" placeholder="Izvēlies datumu"/>
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider 
                                    tag="div"
                                    vid="email"
                                    mode="lazy"
                                    rules="required|email"
                                    :skipIfEmpty="false"
                                    :customMessages="{email: 'E-pasts ievadīts nepareizi', required: 'Jānorāda e-pasts'}"
                                    v-slot="{errors}">
                    <label for="email" class="d-block text-secondary text-left mb-0">E-pasts</label>
                    <input type="text" id="email" class="w-100 py-1 ds-input" v-model="userEmail">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>

            <div class="col-sm-6 py-4">
                <ValidationProvider tag="div"
                                    vid="username"
                                    class="mb-4"
                                    mode="lazy"
                                    rules="required"
                                    :customMessages="{required: 'Norādi darbinieka lietotājvārdu.'}"
                                    v-slot="{errors}">
                    <label for="username" class="d-block text-secondary text-left mb-0">Lietotājvārds</label>
                    <input type="text" id="username" class="w-100 py-1 ds-input" v-model="user.username">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider tag="div"
                                    vid="userGroup"
                                    class="mb-4"
                                    mode="lazy"
                                    v-slot="{errors}">
                    <label class="d-block text-secondary text-left mb-0">Darbinieku grupa</label>
                    <b-form-select id="userGroup" class="w-100 py-1 ds-input" v-model="user.userGroup" :options="usersGroupsOptions"/>
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider v-if="currentUser.isAdmin"
                                    tag="div"
                                    vid="role"
                                    class="mb-4"
                                    mode="lazy"
                                    v-slot="{errors}">
                    <label class="d-block text-secondary text-left mb-0">Loma</label>
                    <b-form-select id="role" class="w-100 py-1 ds-input" v-model="user.role" :options="usersRoles"/>
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>

                <div v-if="user._id">
                    <h6 class="mt-0 mb-4">Darbības</h6>
                    <font-awesome-icon icon="user-secret"/>
                    <a href="javascript:" class="text-dark d-inline-block ml-2 mb-4" @click="resetUserPassword">
                        Veikt paroles maiņu
                    </a>
                </div>
            </div>
            <CustomButton class="w-25 mb-4 ds-btn--success" :btn-text="user._id ? 'Saglabāt izmaiņas' : 'Pievienot'"
                          :is-loading="isActiveRequest"/>
            <div class="ml-4">
                <label for="isOnLongTermLeave">Ilgstošā prombūtnē</label>
                <input id="isOnLongTermLeave" class="ml-2" type="checkbox" v-model="user.isOnLongTermLeave"/> 
            </div>
            <div v-if="(currentUser.isAdmin || currentUser.isManager) && userEmail.length && !user._id" class="ml-4">
                <label for="sendMail">Izsutīt e-pastu</label>
                <input id="sendMail" class="ml-2" type="checkbox" v-model="sendCreateMail"/>
            </div>

        </ValidationObserver>
    </div>
</template>
<script>
    import {mapGetters, mapActions, mapMutations} from 'vuex';
    import axios from 'axios';

    import {ValidationObserver, ValidationProvider, extend} from 'vee-validate';
    import {email, required} from 'vee-validate/dist/rules';

    import CustomButton from '@/components/global/CustomButton';
    import * as userStoreTypes from '../../vuex/modules/user/user.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import * as rootStoreTypes from '../../vuex/root.store-types';
    import * as authStoreTypes from '../../vuex/modules/auth/auth.store-types';
    import {User} from '../../vuex/modules/user/models/user.models';

    export default {
        name: 'users-base-form',
        components: {
            CustomButton,
            ValidationProvider,
            ValidationObserver,
        },
        data() {
            return {
                user: { role: 'user', ...this.$store.state.user.selectedUser},
                isPasswordHidden: true,
                usersRoles: [{value: 'manager', text: 'Menedžeris'}, {value: 'user', text: 'Darbinieks'}],
                userEmail: '',
                sendCreateMail: false,

            }
        },
        created() {
            extend('required', required);
            extend('email', email);

            this.userEmail = this.user.email;
            
            if (this.currentUser.email === 'admin@admin.com') {
                this.usersRoles.push({value: 'admin', text: 'Administrators'});
            }

        },
        methods: {
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
            ...mapActions('user', {
                /** @type {function|*} */
                addUser: userStoreTypes.ACTION_ADD_USER,
                /** @type {function|*} */
                updateUser: userStoreTypes.ACTION_UPDATE_USER,
            }),
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if (!isValid) {
                    return;
                }

                this.user.email = this.userEmail;

                try {
                    if (this.user._id) {
                        await this.updateUser({companyId: this.$route.params.companyId || this.currentUser.company._id, user: this.user});
                        this.reset();
                        return this.setAlertData({type: 'primary', message: 'Darbinieka izmaiņas saglabātas!'});
                    }
                    await this.addUser({companyId: this.$route.params.companyId || this.currentUser.company._id, 
                                        user: this.user,
                                        sendCreateMail: this.sendCreateMail});
                    this.setAlertData({type: 'success', message: 'Darbinieks pievienots!'});
                    this.reset();
                } catch (errors) {
                    this.$refs.observer.setErrors(errors);
                }
            },
            reset() {
                this.user = new User;
                this.$refs.observer.reset();
                this.$emit('finished');
            },
            /**
             * @param {string} logoUrl
             */
            setLogoUrl(logoUrl) {
                this.user.logo = logoUrl;
            },
            resetUserPassword() {
                this.$bvModal.msgBoxConfirm('Šī darbība izveidos jaunu pagaidu paroli lietotājam!',
                {
                    title: 'Apstirprināt paroles maiņu',
                    okTitle: 'Apstiprināt',
                    cancelTitle: 'Atcelt'
                }).then(async value => {
                    if (value) {
                        const {data: { success } } = await axios.put(`/api/companies/${this.currentCompany.id}/users/${this.user._id}/reset-password`);

                        if (success) {
                            this.setAlertData({type: 'success', message: 'Lietotāja parole nomainīta'})
                        }
                    } 
                }).catch(() => {
                    this.setAlertData({type: 'danger', dismissSecs: 10, message: 'Paroles maiņas laikā notika kļūda!'})
                })
                
            }
        },
        computed: {
            ...mapGetters('user', {
                /** @type {boolean|*} */
                isActiveRequest: userStoreTypes.GET_IS_ACTIVE_REQUEST,
            }),
            ...mapGetters('company', {
                /** @type {boolean|*} */
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
            ...mapGetters('auth', {
                /** @type {CurrentUser|*} */
                currentUser: authStoreTypes.GET_CURRENT_USER,
            }),
            usersGroupsOptions() {
                return this.currentCompany.usersGroups.reduce((groups, {_id, name}) => {

                    groups.push({value: _id, text: name});

                    return groups;
                }, [{value: null, text: 'Nav grupas'}]);
            },
            jobTitleOptions() {
                return this.currentCompany.jobTitles.reduce((jobTitles, {_id, name, subName}) => {
                    
                    const formatedSubName = subName ? `(${subName})` : '';

                    jobTitles.push({value: _id, text: `${name} ${formatedSubName}`});

                    return jobTitles;
                }, [{value: null, text: 'Nav amatu identifikatoru'}]);
            }
        }
    }
</script>